<h1>Verwenden und Kombinieren unterschiedlicher Medien</h1>
<section class="article">
  <article>
    <div class="text">
      <p>
        Screen-Videos sind ein gutes Werkzeug zur Darstellung von
        Software-Anwendungen. Z.&nbsp;B. können sie Installationsvorgänge
        dokumentieren, neue Eigenschaften der Software vorstellen oder generell
        bei der Einarbeitung in eine Software-Anwendung unterstützen. Die
        Aufzeichnung der Bildschirmaktivitäten ermöglicht dem Anwender den
        unmittelbaren Transfer. – So lassen sich Video-Anleitungen auch in den
        Bereichen Verwaltung und IT einsetzen zur Einarbeitung neuer Mitarbeiter
        oder für weitere Schulungszwecken.
      </p>
      <p>
        Auch bei der Bedienung von Maschinen und Anlagen ergibt sich aus der
        Steuerungstechnik die Anforderung an einen sicheren Umgang mit der
        zugrunde liegenden Software.
      </p>
      <p>
        Mit video2manual lassen sich reale Filmaufnahmen, die mechanische
        Handlungsschritte zeigen, kombinieren mit Screen-Videos zur Bedienung
        der Software oder auch mit Animationen. Animationen können reale
        Filmaufnahmen ersetzen oder ergänzen, wenn z. B. schlecht zugängliche
        Stellen gezeigt oder komplexe Abläufe vereinzelt oder vereinfacht
        abgebildet werden sollen.
      </p>
      <p>
        Video2manual verarbeitet Filmquellen mit den Formaten*.mp4, *.webm,
        *.mpeg, *.flv, *.mts und *.mov.
      </p>
    </div>
    <a [routerLink]="['/blog']" class="call">Zurück zur Übersicht</a>
  </article>
</section>
